import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import ItemDiscountCodeInputWithButton
    from "pages/Components/CartAndCheckout/components/Item/ItemDiscountCodeInputWithButton";

type Props = {
    isEmptyItems: boolean,
    appliedDiscountCode: string,
    onChange: (promoCode: string) => Promise<void>,
};

const ItemDiscountCode: React.FC<Props> = (
    {
        isEmptyItems,
        appliedDiscountCode = "",
        onChange,
    }
) => {
    const theme: Theme = useTheme();

    const style = css`
        display: flex;
        align-items: center;
    `;

    const textStyle = css`
        margin-right: 32px;
        font-size: 13px;
        line-height: 17px;
        color: ${theme.colours.gray};

        ${theme.breakpoints.only('xl')} {
            margin-right: 21px;
        }

        ${theme.breakpoints.down('lg')} {
            display: none;
        }
    `;

    return (
        <div css={style}>
            <div css={textStyle}>Do you have a promo code?</div>
            <ItemDiscountCodeInputWithButton
                isEmptyItems={isEmptyItems}
                onChange={onChange}
                appliedDiscountCode={appliedDiscountCode}
            />
        </div>
    );
};

export default ItemDiscountCode;